import type { ReactNode } from 'react';
import { SortableTable, type SortColumn, type SortRow } from './SortableTable';
import './insights.css';

export interface SeeTheNumbersProps {
  columns: readonly SortColumn[];
  rows: readonly SortRow[];
  /** Spoken name of the table. */
  caption: string;
}

/**
 * The table behind a chart, folded under it (dataviz: a table view always exists), sortable by any
 * heading, so the numbers are there for a screen reader, for copying into an email, and for anyone
 * who wants them exact or ranked.
 */
export function SeeTheNumbers({ columns, rows, caption }: SeeTheNumbersProps): ReactNode {
  return (
    <details className="ad-numbers">
      <summary>See the numbers</summary>
      <div className="ad-numbers__scroll">
        <SortableTable columns={columns} rows={rows} caption={caption} />
      </div>
    </details>
  );
}
